import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DropzoneConfigInterface, DropzoneComponent } from 'ngx-dropzone-wrapper';
import { UploadS3Service } from 'app/core/services/uploadFile.service';
import { imageSieCheck } from './imageSizeCheck';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss'],
})
export class CommonDropzoneComponent {
  @ViewChild('dz') drpzone!: DropzoneComponent;
  signedURL: string = '';
  binaryFile!: any;
  @Output() successEvent: EventEmitter<{ param1: string; param2: any; param3: any }> = new EventEmitter<{
    param1: string;
    param2: any;
    param3: any;
  }>();
  @Output() errorEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sending: EventEmitter<any> = new EventEmitter<any>();
  @Input() DrpzoneparamName: string = '';
  @Input() acceptedRatioWidth?: number;
  @Input() acceptedRatioheight?: number;
  @Input() name: string = '';
  @Input() message: string = '';
  @Input() maxFiles: number = 5;
  @Input() acceptedFile?: string[];
  // @Input() isDisabled: boolean = false;
  public config: DropzoneConfigInterface = {
    clickable: true,
    autoReset: 1,
    errorReset: 1,
    createImageThumbnails: false,
    paramName: this.DrpzoneparamName,
    method: 'put',
    maxFiles: this.maxFiles,
    url: () => {
      return this.signedURL;
    },
    autoProcessQueue: false,
    // renameFile: (file) => Date.now() + '-' + file.name,
    renameFile: (file) => Date.now().toString(),
    accept: async (file: any, done) => {
      try {
        const ratio = imageSieCheck(this.DrpzoneparamName);
        const filePath = this.uploadS3service.generateDynamicUploadPath(this.DrpzoneparamName, file.upload.filename);
        const binaryData = await this.getBinaryData(file);
        const obj = {
          urls: [{ key: this.DrpzoneparamName, value: filePath }],
        };
        if (this.acceptedFile && !this.acceptedFile?.includes(file.type)) {
          this.config.dictRemoveFile = '';
          done(
            this.translate.instant('only.value') +
              ' ' +
              this.acceptedFile.join() +
              ' ' +
              this.translate.instant('isAllowed.value'),
          );
          return;
        }
        if (!(ratio.height === 0 && ratio.width === 0)) {
          const dimensions = await this.getImageDimensions(file);
          if (!this.areDimensionsMatching(ratio, dimensions)) {
            this.config.dictRemoveFile = '';
            done(this.translate.instant('imageDimensionError.value'));
            return;
          }
        }
        if (this.acceptedRatioWidth && this.acceptedRatioheight) {
          const dimensions = await this.getImageDimensions(file);
          if (!this.areRatioMatching(dimensions, this.acceptedRatioWidth, this.acceptedRatioheight)) {
            this.config.dictRemoveFile = '';
            done(
              `${this.translate.instant('imageRatioError.value')}  ${this.acceptedRatioWidth} by ${this.acceptedRatioheight}`,
            );
            return;
          }
        }
        const response = await this.uploadS3service.uploadFile(obj);
        this.signedURL = response?.message?.urls[0]?.value;

        const xhr = new XMLHttpRequest();
        xhr.open('PUT', this.signedURL, true);

        // Set Content-Type and other headers as needed
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');

        // Handle the progress of the upload
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentage = (event.loaded / event.total) * 100;
            // Manually update the progress here if needed
            this.drpzone.directiveRef?.dropzone().emit('uploadprogress', file, percentage);
            // if (percentage === 100) {
            // this.drpzone.directiveRef?.dropzone().removeFile(file);
            // this.drpzone.directiveRef?.dropzone().processQueue();
            // this.drpzone.directiveRef?.dropzone().emit('success', file, file);
            // }
          }
        };

        xhr.onloadend = (event) => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            this.drpzone.directiveRef?.dropzone().removeFile(file);
            this.drpzone.directiveRef?.dropzone().processQueue();
            this.drpzone.directiveRef?.dropzone().emit('success', file, file);
          } else {
            done(`Failed to upload file: ${xhr.status} ${xhr.statusText}`);
          }
        };
        xhr.onerror = () => {
          done('Failed to upload file'); // Handle upload failure
        };
        // Send the binary data directly
        xhr.send(binaryData);
      } catch (error) {
        done('Error in accept function', error);
      }
    },

    uploadMultiple: false,
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.maxFiles?.firstChange) {
      this.config.maxFiles = changes.maxFiles.currentValue;
      this.config.uploadMultiple = this.maxFiles > 1;
    }
  }

  private areDimensionsMatching(
    expectedRatio: { height: number; width: number },
    actualDimensions: { width: number; height: number },
  ): boolean {
    const { width, height } = actualDimensions;
    const isMatching = height === expectedRatio.height && width === expectedRatio.width;
    return isMatching;
  }

  private getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          img.onload = () => {
            resolve({ width: img.width, height: img.height });
          };
          img.src = event.target.result as string;
        } else {
          reject('Failed to read file as binary data');
        }
      };
      reader.onerror = () => {
        reject('Error reading file');
      };
      reader.readAsDataURL(file);
    });
  }

  private areRatioMatching(
    actualDimensions: { height: number; width: number },
    acceptedWidth: number,
    acceptedHeight: number,
  ) {
    const { width, height } = actualDimensions;
    const isMatching = this.customeCeil(width / height) === this.customeCeil(acceptedWidth / acceptedHeight);
    return isMatching;
  }

  private customeCeil(value: number) {
    const intpart = Math.floor(value);
    if (value - intpart >= 0.5) {
      return intpart + 1;
    }
    return intpart;
  }
  constructor(
    public uploadS3service: UploadS3Service,
    public translate: TranslateService,
  ) {}

  private getBinaryData(file: File): Promise<Uint8Array> {
    return new Promise<Uint8Array>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result instanceof ArrayBuffer) {
          const binaryData: Uint8Array = new Uint8Array(event.target.result);
          resolve(binaryData);
        } else {
          reject('Failed to read file as binary data');
        }
      };
      reader.onerror = () => {
        reject('Error reading file');
      };
      reader.readAsArrayBuffer(file);
    });
  }

  getBinaryFromFile(file: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener('load', () => resolve(reader.result));
      reader.addEventListener('error', (err) => reject(err));

      reader.readAsBinaryString(file);
    });
  }
  processing(file: any) {
    this.config.url = file.uploadURL;
  }

  handleUploadSuccess(Data: any, value?: any) {
    const [file] = Data;
    const filePath = this.uploadS3service.generateDynamicUploadPath(this.DrpzoneparamName, file.upload.filename);
    this.successEvent.emit({ param1: filePath, param2: Data, param3: value });
  }
  handleonErrorUpload(Data: any) {
    this.errorEvent.emit(Data);
  }
}
